























































































import { Vue, Component, Prop } from "vue-property-decorator";
import ToastMessage from "@/components/ToastMessage.vue";
import ProgressBar from "@/components/ProgressBar.vue";
import ProductCard from "@/components/ProductCard.vue";
import ProductCardInner from "@/components/ProductCardInner.vue";
import ProductCardContainer from "@/components/ProductCardContainer.vue";
import FilterTab from "@/components/FilterTab.vue";
import QuantityCounter from "@/components/QuantityCounter.vue";
import SummaryLine from "@/components/SummaryLine.vue";
import VasSidebar from "@/components/vas/Sidebar.vue";
import InlineCart from "@/components/InlineCart.vue";
import NoDeliverySlotsNotice from "@/components/NoDeliverySlotsNotice.vue";
import { SlideXRightTransition } from "vue2-transitions";
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import { shallowEqualObjects } from "shallow-equal";
import { Route, NavigationGuardNext } from "vue-router";
import { ROUTES_MAP } from "@/router";
import Store from "@/store";
import QS from "query-string";
import QrCodeDeepLinkModal from '@/components/QrCodeDeepLinkModal.vue'
import VasSidebarWeshope from "@/components/vas/SidebarWeshope.vue";
import { isWishope, getDescriptionByCurrentVas } from "@/common/utils";

Component.registerHooks(["beforeRouteUpdate", "beforeRouteEnter"]);

const VasDetailsStandardProps = Vue.extend({
  computed: {
    ...mapState("vas", ["saleType", "merchantDetails", "merchantShopDetails"]),
    ...mapState("global", ["cart", "checkout", "showHeader"]),
    ...mapGetters("vas", [
      "merchant",
      "isEnabled",
      "hasNoDeliverySlots",
      "hasDelivery",
      "requiresDeliverySlots",
      "hasAvailableSlots",
      "hasScheduledPickupAvailable",
      "availableSaleTypes",
    ]),
  },
  methods: {
    ...mapActions("vas", ["fetchMerchant"]),
    isWishope,
    getDescriptionByCurrentVas,
  },
});

@Component({
  components: {
    ToastMessage,
    ProgressBar,
    ProductCard,
    ProductCardInner,
    ProductCardContainer,
    FilterTab,
    QuantityCounter,
    SummaryLine,
    VasSidebar,
    InlineCart,
    NoDeliverySlotsNotice,
    SlideXRightTransition,
    QrCodeDeepLinkModal,
    VasSidebarWeshope,
  },
  metaInfo() {
    return {
      meta: [
        { name: "og:title", content: (this as VasDetailsStandard).merchantShopDetails?.name },
        { name: "og:description", content: (this as VasDetailsStandard).merchantShopDetails?.description },
        { name: "og:image", content: (this as VasDetailsStandard).merchantShopDetails?._links?.hero?.href },
      ]
    };

  },
})
export default class VasDetailsStandard extends VasDetailsStandardProps {

  isVisibleQrCodeDeeplinkModal = false;

  get progressDisabled() {
    return this.checkout && this.checkout.status === "PAYMENT_SUCCESS";
  }

  get isPaymentView() {
    return this.$route.name === "PublicVAS__payment";
  }

  get currentSaleType() {
    return this.merchant.id;
  }

  set currentSaleType(id) {
    this.setCurrentVasId(id);
  }

  setCurrentVasId(vasId: string) {
    if (String(vasId) == this.merchant.id) return null;
    if (this.$route.name) {
      this.$router.push({
        name: ROUTES_MAP.VAS_PRODUCTS,
        params: {
          ...this.$route.params,
          vasId: String(vasId),
        },
      });
    }
  }

  async beforeRouteUpdate(to: any, from: any, next: any) {
    if (!shallowEqualObjects(to.params, from.params)) {
      await this.fetchMerchant(to.params);
    }
    next();
  }

  async beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    const urlParams = QS.parse(location.search);
    const hashParams = QS.parse(location.hash.replaceAll("?", ""));

    if (urlParams["alipay_checkout"] || hashParams["alipay_checkout"]) {
      await Store.dispatch("global/fetchCheckoutWithID", {
        id: urlParams["alipay_checkout"]
          ? urlParams["alipay_checkout"]
          : hashParams["alipay_checkout"],
        isRedirect: true,
      });
    }
    await Store.dispatch("vas/fetchMerchant", to.params);
    next();
  }

  created() {

    // If VAS is closed, redirect to https://bancaprofilo.tinaba.it/
    if (this.merchantDetails && this.merchantDetails.status === 'CLOSED') {
      window.location.href = 'https://bancaprofilo.tinaba.it/';
    }
  }
}
